import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import moment from 'moment-jalaali';
import { ConvertDateToJalali } from './ConvertDateToJalali';

export const Base64Selector = (
  event,
  setter,
  excludeHeader = false
) => {
  const file = event.target.files[0];
  if (
    file.type.includes('image/') ||
    file.type.includes('application/pdf')
  ) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setter({
        fileName: file.name,
        fileContent: excludeHeader
          ? reader.result.split(',')[1]
          : reader.result,
        fileDate: ConvertDateToJalali(
          moment(file.lastModified)
        ),
      });
    };
    reader.onerror = () => {
      console.log('file Error');
    };
  } else {
    SwalAlert('error', 'لطفا تصویری انتخاب کنید', false);
  }
};
